import { useEffect, useState } from "react";

import {
  addressTypes,
  customerSituations,
  licenseesContractTypes,
} from "../../../utils/constants";
import { IAddress, IPlans, Licensee } from "../dtos";

import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { StaticDatePicker } from "@mui/x-date-pickers/StaticDatePicker";

import {
  MdPublishedWithChanges,
  MdOutlineWorkOutline,
  MdOutlineHomeWork,
  MdWorkOutline,
  MdOutlineDeliveryDining,
  MdOutlineNotInterested,
} from "react-icons/md";
import { VscGear } from "react-icons/vsc";
import {
  FaExchangeAlt,
  FaRegAddressCard,
  FaRegMoneyBillAlt,
} from "react-icons/fa";
import { FiEye, FiUsers } from "react-icons/fi";
import { IoIosArrowBack } from "react-icons/io";
import { BsBook, BsCalendarCheck, BsCalendarMinus } from "react-icons/bs";
import { RiCheckboxCircleLine } from "react-icons/ri";
import { BiUserPin, BiMoney, BiDollarCircle } from "react-icons/bi";
import {
  AiOutlineHome,
  AiOutlineLock,
  AiOutlineUnlock,
  AiOutlineWarning,
} from "react-icons/ai";

import {
  AddressActions,
  AdvancedOptionsAction,
  ContractTypeOptions,
  MobileActions,
  MobileActiveOption,
  MobileOption,
  StatusActions,
} from "../pages/LicenseesList/components/LicenseeItem/styles";
import { Modal } from "../../../components/Modal";
import { TextField } from "@mui/material";
import { DateContainer } from "../styles";
import { HiOutlineDocumentText } from "react-icons/hi";
import { AddFixcoinModal } from "../components/AddFixcoinModal";
import { LuFileSignature } from "react-icons/lu";
import { ISignature } from "../../../hooks/OnboardContext";
import { SignatureInfoModal } from "../components/SignatureInfoModal";
import { LicenseeProvisionerList } from "../components/LicenseeProvisionerList";

export interface AdminProps {
  licensee: Licensee;
  addresses: IAddress[];
  licenseeSignature?: ISignature;
  activePlans: IPlans[];
  signatureOptions: boolean;
  addressOptions: boolean;
  statusOptions: boolean;
  advancedOptions: boolean;
  contractTypeOptions: boolean;
  signatureModal: boolean;
  handleDeactivateActiveSignature: () => void;
  handleBlockLicensee: () => void;
  handleChurnLicensee: (churn_date: Date) => void;
  handleRestoreLicensee: () => void;
  handleAssignPlanToPerson: (
    licensee_id: string,
    plan_id?: string | number,
    user_terms_id?: string,
    payment_value?: string,
    payment_recurrency?: string | number
  ) => void;
  handleChangeLicenseeSituation: (id: string, situation: string) => void;
  handleGetLicenseeSignature: (id: string) => void;
  handleChangeLicenseePlan: (
    licensee_id: string,
    plan_id?: string | number,
    user_terms_id?: string,
    payment_value?: string,
    payment_recurrency?: string | number
  ) => void;
  handleRenderAddressOptions: (id: string) => void;
  handleRenderAddress: (id: string) => void;
  handleChangeLicenseeContractType: (id: string, contract_type: string) => void;
  getPlans: (currency: string, is_active: boolean) => void;
  toggleStatusOptions: () => void;
  toggleAdvancedOptions: () => void;
  toggleSignatureModal: () => void;
  toggleAddressOptions: () => void;
  toggleContractTypeOptions: () => void;
  onDetailsIconClick?: () => void;
  handleRender: () => void;
}

export const AdminActions = ({
  licensee,
  addresses,
  licenseeSignature,
  activePlans,
  signatureOptions,
  statusOptions,
  advancedOptions,
  addressOptions,
  contractTypeOptions,
  signatureModal,
  handleDeactivateActiveSignature = () => { },
  handleBlockLicensee = () => { },
  handleChurnLicensee = () => { },
  handleRestoreLicensee = () => { },
  handleRenderAddressOptions = () => { },
  handleAssignPlanToPerson = () => { },
  handleChangeLicenseeSituation = () => { },
  handleGetLicenseeSignature = () => { },
  handleChangeLicenseePlan = () => { },
  handleRenderAddress = () => { },
  toggleAdvancedOptions = () => { },
  toggleStatusOptions = () => { },
  toggleSignatureModal = () => { },
  toggleAddressOptions = () => { },
  toggleContractTypeOptions = () => { },
  getPlans = () => { },
  onDetailsIconClick = () => { },
  handleChangeLicenseeContractType = () => { },
}: AdminProps) => {
  const [churnDate, setChurnDate] = useState<Date>(new Date());
  const [openSelectChurnDate, setOpenSelectChurnDate] = useState(false);
  const [openAddFixcoinModal, setOpenAddFixcoinModal] = useState(false);
  const [openProvisionerModal, setopenProvisionerModal] = useState(false);
  const [providerSelected, setProviderSelected] = useState(false);

  const licenseeStatus = [
    {
      defaultComponent: (
        <MobileOption
          onClick={(event) => {
            handleChangeLicenseeSituation(
              licensee.id,
              customerSituations.onboarding
            );
          }}
        >
          <BiUserPin />
          <span>Onboarding</span>
        </MobileOption>
      ),
      checkedComponent: (
        <MobileOption>
          <BiUserPin />
          <span>Onboarding</span>
          <RiCheckboxCircleLine className="checked" />
        </MobileOption>
      ),
      value: "onboarding",
    },
    /*{
      defaultComponent: (
        <MobileOption
          onClick={(event) => {
            handleChangeLicenseeSituation(
              licensee.id,
              customerSituations.effected
            );
          }}
        >
          <BiMoney />
          <span>Venda Efetivada</span>
        </MobileOption>
      ),
      checkedComponent: (
        <MobileOption>
          <BiMoney />
          <span>Venda Efetivada</span>
          <RiCheckboxCircleLine className="checked" />
        </MobileOption>
      ),
      value: "effected",
    },
    {
      defaultComponent: (
        <MobileOption
          onClick={(event) => {
            handleChangeLicenseeSituation(
              licensee.id,
              customerSituations.training
            );
          }}
        >
          <BsBook />
          <span>Em Treinamento</span>
        </MobileOption>
      ),
      checkedComponent: (
        <MobileOption>
          <BsBook />
          <span>Em Treinamento</span>
          <RiCheckboxCircleLine className="checked" />
        </MobileOption>
      ),
      value: "training",
    },
    {
      defaultComponent: (
        <MobileOption
          onClick={(event) => {
            handleChangeLicenseeSituation(
              licensee.id,
              customerSituations.implementation
            );
          }}
        >
          <MdOutlineHomeWork />
          <span>Em Implantação</span>
        </MobileOption>
      ),
      checkedComponent: (
        <MobileOption>
          <MdOutlineHomeWork />
          <span>Em Implantação</span>
          <RiCheckboxCircleLine className="checked" />
        </MobileOption>
      ),
      value: "implementation",
    },
    */
    {
      defaultComponent: (
        <MobileOption
          onClick={(event) => {
            handleChangeLicenseeSituation(
              licensee.id,
              customerSituations.active
            );
          }}
        >
          <MdOutlineWorkOutline />
          <span>Ativo</span>
        </MobileOption>
      ),
      checkedComponent: (
        <MobileOption>
          <MdOutlineWorkOutline />
          <span>Ativo</span>
          <RiCheckboxCircleLine className="checked" />
        </MobileOption>
      ),
      value: "active",
    },
  ];

  useEffect(() => {
    if (Boolean(!licenseeSignature)) {
      handleGetLicenseeSignature(licensee.id);
    }
  }, [signatureOptions]);

  useEffect(() => {
    if (licensee.country === "BRA") {
      getPlans("BRL", false);
    } else {
      getPlans("USD", false);
    }
  }, []);

  // function renderSignatureOptions() {
  //   return (
  //     <SignatureActions>
  //       {activePlans.map((plan) => {
  //         if (plan.plan_type === planTypes.demo) {
  //           return (
  //             <MobileActiveOption
  //               is_active={plan.is_active}
  //               onClick={(event) => ChangeOrAssignLicenseePlan(licensee, plan)}
  //             >
  //               <BsStar />
  //               <span>Plano {plan.plan_name}</span>
  //               {licenseeSignature?.plan.plan_name === plan.plan_name ? (
  //                 <RiCheckboxCircleLine className="checked" />
  //               ) : null}
  //             </MobileActiveOption>
  //           );
  //         }
  //         if (plan.plan_type === planTypes.basic) {
  //           return (
  //             <MobileActiveOption
  //               is_active={plan.is_active}
  //               onClick={(event) => ChangeOrAssignLicenseePlan(licensee, plan)}
  //             >
  //               <BsStarHalf />
  //               <span>Plano {plan.plan_name}</span>
  //               {licenseeSignature?.plan.plan_name === plan.plan_name ? (
  //                 <RiCheckboxCircleLine className="checked" />
  //               ) : null}
  //             </MobileActiveOption>
  //           );
  //         }
  //         if (plan.plan_type === planTypes.advanced) {
  //           return (
  //             <MobileActiveOption
  //               is_active={plan.is_active}
  //               onClick={(event) => ChangeOrAssignLicenseePlan(licensee, plan)}
  //             >
  //               <BsStarFill />
  //               <span>Plano {plan.plan_name}</span>
  //               {licenseeSignature?.plan.plan_name === plan.plan_name ? (
  //                 <RiCheckboxCircleLine className="checked" />
  //               ) : null}
  //             </MobileActiveOption>
  //           );
  //         } else {
  //           return (
  //             <MobileActiveOption
  //               is_active={plan.is_active}
  //               onClick={(event) => ChangeOrAssignLicenseePlan(licensee, plan)}
  //             >
  //               <GoEyeClosed className="not_visible" />
  //               <span>Plano {plan.plan_name}</span>
  //               {licenseeSignature?.plan.plan_name === plan.plan_name ? (
  //                 <RiCheckboxCircleLine className="checked" />
  //               ) : null}
  //             </MobileActiveOption>
  //           );
  //         }
  //       })}
  //     </SignatureActions>
  //   );
  // }

  function renderStatusOptions() {
    return (
      <StatusActions>
        {licenseeStatus.map((l) => {
          if (licensee.situation === l.value) {
            return l.checkedComponent;
          }
          return l.defaultComponent;
        })}
      </StatusActions>
    );
  }

  function renderAddressOptions() {
    return (
      <AddressActions>
        {addresses &&
          addresses.map((add, index) => {
            if (add.type === addressTypes.other) {
              return (
                <MobileActiveOption
                  onClick={(event) => {
                    handleRenderAddress(add.id);
                  }}
                >
                  <FaRegAddressCard size={16} />
                  <span>Outro {`${index}`} </span>
                  {add.deliver_address === true ? (
                    <MdOutlineDeliveryDining className="checked" />
                  ) : null}
                  {add.billing_address === true ? (
                    <FaRegMoneyBillAlt className="checked" />
                  ) : null}
                </MobileActiveOption>
              );
            }
            if (add.type === addressTypes.home) {
              return (
                <MobileActiveOption
                  onClick={(event) => {
                    handleRenderAddress(add.id);
                  }}
                >
                  <AiOutlineHome size={16} />
                  <span>Casa</span>
                  {add.deliver_address === true ? (
                    <MdOutlineDeliveryDining className="checked" />
                  ) : null}
                  {add.billing_address === true ? (
                    <FaRegMoneyBillAlt className="checked" />
                  ) : null}
                </MobileActiveOption>
              );
            }

            if (add.type === addressTypes.work) {
              return (
                <MobileActiveOption
                  onClick={(event) => {
                    handleRenderAddress(add.id);
                  }}
                >
                  <MdWorkOutline size={16} />
                  <span>Trabalho</span>
                  {add.deliver_address === true ? (
                    <MdOutlineDeliveryDining className="checked" />
                  ) : null}
                  {add.billing_address === true ? (
                    <FaRegMoneyBillAlt className="checked" />
                  ) : null}
                </MobileActiveOption>
              );
            }
          })}
      </AddressActions>
    );
  }

  function renderAdvancedOptions() {
    return (
      <AdvancedOptionsAction>
        <MobileActiveOption
          onClick={() => {
            licensee.churned_at
              ? handleRestoreLicensee()
              : setOpenSelectChurnDate(true);
          }}
        >
          <MdOutlineNotInterested color={"red"} />
          <span>
            {licensee.churned_at ? "Desfazer distrato" : "Realizar distrato"}
          </span>
        </MobileActiveOption>

        <MobileActiveOption
          is_active={true}
          onClick={() => {
            handleBlockLicensee();
          }}
        >
          {licensee?.is_blocked ? (
            <AiOutlineLock color="red" />
          ) : (
            <AiOutlineUnlock color="red" />
          )}
          <span>
            {licensee.is_blocked
              ? "Desbloquear licenciado"
              : "Bloquear licenciado"}
          </span>
        </MobileActiveOption>

        {licenseeSignature && (
          <MobileActiveOption
            is_active={true}
            onClick={() => {
              handleDeactivateActiveSignature();
            }}
          >
            <AiOutlineWarning color="red" />
            <span>{"Desativar assinatura"}</span>
          </MobileActiveOption>
        )}
      </AdvancedOptionsAction>
    );
  }

  function renderContractTypeOptions() {
    return (
      <ContractTypeOptions>
        <MobileActiveOption
          onClick={() =>
            handleChangeLicenseeContractType(
              licensee.id,
              licenseesContractTypes.monthly
            )
          }
        >
          <BsCalendarMinus color={"var(--fixit)"} />
          <span>{"Mensal"}</span>
          {licensee.contract_type === licenseesContractTypes.monthly ? (
            <RiCheckboxCircleLine className="checked" />
          ) : null}
        </MobileActiveOption>

        <MobileActiveOption
          onClick={() =>
            handleChangeLicenseeContractType(
              licensee.id,
              licenseesContractTypes.annual
            )
          }
        >
          <BsCalendarCheck color="var(--fixit)" />
          <span>{"Anual"}</span>
          {licensee.contract_type === licenseesContractTypes.annual ? (
            <RiCheckboxCircleLine className="checked" />
          ) : null}
        </MobileActiveOption>
      </ContractTypeOptions>
    );
  }

  function toggleDateModal() {
    setOpenSelectChurnDate(!openSelectChurnDate);
  }

  function toggleFixcoinModal() {
    setOpenAddFixcoinModal(!openAddFixcoinModal);
  }

  function toggleProvisionerModal() {
    setopenProvisionerModal((prevState) => !prevState);
  }

  function toggleProvisionerSelected() {
    setProviderSelected(true);
  }

  return (
    <>
      {/* {signatureOptions && renderSignatureOptions()} */}
      {statusOptions && renderStatusOptions()}
      {addressOptions && renderAddressOptions()}
      {advancedOptions && renderAdvancedOptions()}
      {contractTypeOptions && renderContractTypeOptions()}

      <Modal
        open={openSelectChurnDate}
        modalWidth={550}
        onRequestClose={toggleDateModal}
      >
        <DateContainer>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <StaticDatePicker
              orientation="landscape"
              disableFuture
              onAccept={() => {
                handleChurnLicensee(churnDate);
                setOpenSelectChurnDate(false);
              }}
              value={churnDate}
              onChange={(value) => {
                setChurnDate(value ?? new Date());
              }}
              renderInput={(params) => <TextField {...params} />}
            />
          </LocalizationProvider>
        </DateContainer>
      </Modal>

      <Modal open={openAddFixcoinModal} onRequestClose={toggleFixcoinModal}>
        <AddFixcoinModal
          licensee_id={licensee.id}
          onHandleCloseRequest={toggleFixcoinModal}
        />
      </Modal>

      <Modal open={signatureModal} modalWidth={500}>
        <SignatureInfoModal
          licensee={licensee}
          licenseeSignature={licenseeSignature}
          onRequestClose={toggleSignatureModal}
          activePlans={activePlans}
          handleAssignPlanToPerson={handleAssignPlanToPerson}
          handleChangeLicenseePlan={handleChangeLicenseePlan}
        />
      </Modal>

      <LicenseeProvisionerList
        handleProviderSelected={() => {
          toggleProvisionerSelected();
        }}
        trigger={openProvisionerModal}
        licenseeIdentification={licensee.id}
        onClose={() => {
          toggleProvisionerModal();
        }}
        licensee={licensee}
      />

      <MobileActions>
        <MobileOption
          onClick={(event: any) => {
            toggleStatusOptions();
            event.stopPropagation();
          }}
        >
          {" "}
          {statusOptions ? <IoIosArrowBack /> : <MdPublishedWithChanges />}
          <span>Modificar Status</span>
        </MobileOption>

        {
          <MobileOption
            onClick={(event: any) => {
              event.stopPropagation();
              toggleSignatureModal();
            }}
          >
            {signatureOptions ? (
              <IoIosArrowBack />
            ) : !licenseeSignature ? (
              <LuFileSignature className="change" />
            ) : (
              <FaExchangeAlt className="change" />
            )}
            <span>
              {!licenseeSignature
                ? `Atribuir assinatura`
                : `Modificar Assinatura`}
            </span>
          </MobileOption>
        }

        <MobileOption
          onClick={(event: any) => {
            toggleFixcoinModal();
            event.stopPropagation();
          }}
        >
          <BiDollarCircle />
          <span>Adicionar Fixcoin</span>
        </MobileOption>

        <MobileOption
          onClick={(event: any) => {
            event.stopPropagation();
            toggleContractTypeOptions();
          }}
        >
          <HiOutlineDocumentText />
          <span>Tipo de contrato</span>
        </MobileOption>

        <MobileOption
          onClick={(event: any) => {
            event.stopPropagation();
            handleRenderAddressOptions(licensee.id);
            toggleAddressOptions();
          }}
          disabled={!addresses.length}
        >
          <FaRegAddressCard
            color={!addresses.length ? "gray" : "var(--fixit)"}
          />
          <span>Endereço</span>
        </MobileOption>

        <MobileOption
          onClick={(event: any) => {
            event.stopPropagation();
            onDetailsIconClick();
          }}
        >
          <FiEye />
          <span>Ver Detalhes</span>
        </MobileOption>

        {licensee.printers?.length <= 0 &&
          <MobileOption
            onClick={(event: any) => {
              event.stopPropagation();
              toggleProvisionerModal();
            }}
          >
            <FiUsers />
            <span>Escolher FixPoint</span>
          </MobileOption>
        }

        <MobileOption
          onClick={(event: any) => {
            event.stopPropagation();
            toggleAdvancedOptions();
          }}
        >
          <VscGear />
          <span>Opções avançadas</span>
        </MobileOption>
      </MobileActions>
    </>
  );
};
